import Modal from "react-bootstrap/Modal";
import Markdown from "react-markdown";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import {AppState} from "../RootReducer";
import {getLoggedIn, isUserInfoLoaded} from "../selectors/user-selectors";
import {useDispatch, useSelector} from "react-redux";
import {getPopupManager, getStatusForContent, isAppPopupEnabledForDevice} from "../selectors/content-selectors";
import {ContentModelName, ImageObject, Popup, PopupPayload} from "../contenful/types";
import {ContentStatus} from "../contenful/ContentfulReducer";
import {detectDeviceOS, localStorageKey, sessionStorageKey, usePrevious} from "../user/ui/utils";
import AppInstallPopUp from "../ui/AppInstallPopUp";
import {AppMode, Settings} from "../http/protocol";
import "./PromotePopupComponent.scss";
import { setPopupStatus } from "./PopupActions";
import { PopupStatus } from "./PopupReducer";
import { getIsAppContextNotNull } from "../selectors/settings-selectors";
import { getPathType } from "../onboardingpage/modalview/utils";
import { PATH } from "../onboardingpage/modalview/UserModalController";


interface ContentfulImage {
    src? : string;
    width: string;
    height?: string;
}
const toImage = (img? : ImageObject) : ContentfulImage | undefined => {
    if(img?.fields?.file?.details) {
        return {
            src : img?.fields.file.url,
            height : img?.fields.file.details.height ?? "",
            width: img?.fields.file.details.width ?? ""

        }
    }
}
const PromotionPopup = (props : { popup : Popup, disableOutsideClick?: boolean, close? : ()=> void }) => {
    const dispatch = useDispatch();

    const closeWithButton = () => {
        dispatch(setPopupStatus(PopupStatus.HIDDEN));
    }

    const closeWithCallbackFunction = props.disableOutsideClick
        ? () => console.log('user must agree to terms and conditions to continue')
        : props.close;

    let popup : Popup = props.popup;
    let imageRedirect = popup.imageRedirect ?? ""
    let img : ContentfulImage | undefined = toImage(popup.image);

    return (
        <Modal show={true}
               onHide={()=> closeWithCallbackFunction?.()}
               aria-labelledby="contained-modal-title-vcenter"
               className={`promoteModalDialog popup-id${popup.id ? popup.id : ''}`}
               size="lg">
            <Modal.Header closeButton className="promoteModalHead">
                <Modal.Title id="contained-modal-title-vcenter" className="promoteModalTitle">
                    {popup.header}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="promoteModalBody">
                <Markdown className="promoteModalText" children={popup.text && popup.text} />
                {img &&
                <div className="imageWrap" onClick={() => {
                    return closeWithCallbackFunction?.()
                }}>
                    {imageRedirect.length > 0 && <Link to={imageRedirect} onClick={() => ()=> closeWithCallbackFunction?.()}><img alt="popup" src={img.src} width={img.width} height={'200'}/></Link>}
                    {imageRedirect.length === 0 &&
                        <>
                            <img alt="popup" src={img.src} width={img.width} height={img.height}/>
                            {props.disableOutsideClick &&
                                <div className={'d-flex justify-content-center'}>
                                    <button
                                        className={'btn btn-cta register-link small fixed-menu-btn topmenu'}
                                        onClick={closeWithButton}>
                                        I Agree!
                                    </button>
                                </div>}
                        </>
                    }
                </div>}
            </Modal.Body>
        </Modal>
    )
}

enum LoadStatus {
    NONE,
    LOGGED_IN,
    LOGGED_OUT
}

export const APP_INSTALL_POPUP_KEY = "appPopupSessionDisplayed";
export const APP_POPUP_DISPLAYED_TIMES = "appInstallPopupDisplayed";

const stopCountingInCurrentSession = () => {
    sessionStorage.setItem(APP_INSTALL_POPUP_KEY, "true");
}
const hasBeenCalledThisSession = () => {
    return sessionStorage.getItem(APP_INSTALL_POPUP_KEY) === "true";
}

export const shouldShowAppInstallPopup = (settings? : Settings) => {
    if(hasBeenCalledThisSession()) {
        return false;
    }
    //how often do we display the popup after the initial delay
    const noOfTimeBeforePromptingAgain = settings?.noOfTimeBeforePromptingAgain ?? 0;
    const delayAppInstallPopup = settings?.delayAppInstallPopup  ?? 0;

    let localAppInstalled = localStorage.getItem('appinstalled');
    const appInstalled = localAppInstalled ? localAppInstalled == "true" : false;

    let appInstallPopUpDisplayed = localStorage.getItem(APP_POPUP_DISPLAYED_TIMES);
    let visits = appInstallPopUpDisplayed ? Number(appInstallPopUpDisplayed) : 0;

    visits++;
    stopCountingInCurrentSession();
    localStorage.setItem(APP_POPUP_DISPLAYED_TIMES, ""+visits);
    if(!appInstalled) {
        if(visits > delayAppInstallPopup) {
            if(visits - 1 == delayAppInstallPopup) {
                return true;
            } else if(noOfTimeBeforePromptingAgain != 0 && (visits - delayAppInstallPopup - 1) % noOfTimeBeforePromptingAgain == 0) {
                return true;
            }
        }
    }
    return false;
}


const shouldShowLoginPopup = (popup? : PopupPayload) => {
    if(!popup) {
        return false;
    }
    const loginPopupStorage = localStorageKey("loginPopup");
    const loginPopupSession = sessionStorageKey("loginPopup");

    if(loginPopupSession.exists()) {
        return false;
    }

    if(!popup.showOnlyOnce) {
        loginPopupStorage.set(popup.id);
        loginPopupSession.set(popup.id);
        return true;
    }
    let popupId = loginPopupStorage.get();
    if(!popupId || popupId !== popup.id) {
        loginPopupStorage.set(popup.id);
        loginPopupSession.set(popup.id);
        return true;
    }

    return false;
}

const shouldShowVisitPopup = (popup? : PopupPayload) => {
    if(!popup) {
        return false;
    }
    const visitPopupStorage = localStorageKey("visitPopup");
    const visitPopupSession = sessionStorageKey("visitPopup");

    if(visitPopupSession.exists()) {
        return false;
    }

    if(!popup.showOnlyOnce) {
        visitPopupStorage.set(popup.id);
        visitPopupSession.set(popup.id);
        return true;
    }
    let popupId = visitPopupStorage.get();
    if(!popupId || popupId !== popup.id) {
        visitPopupStorage.set(popup.id);
        visitPopupSession.set(popup.id);
        return true;
    }

    return false;
}
export const PopupComponent = () => {
    const dispatch = useDispatch();
    const status = useSelector((state: AppState) => state.popup.popupStatus)
    const [loggedOutReady, setLoggedOutReady] = useState(false);
    const location = useLocation();
    const [loggedInReady, setLoggedInReady] = useState(false);
    const appMode = useSelector((appState: AppState) => appState.user.appMode)
    const settings = useSelector((app : AppState) => app.settings.settings);
    const loggedIn = useSelector((app : AppState) => getLoggedIn(app));
    const userInfoLoaded = useSelector((app : AppState) => isUserInfoLoaded(app));
    const popup = useSelector((app : AppState) => getPopupManager(app));
    const popupContentLoaded = useSelector((app : AppState) => getStatusForContent(app, ContentModelName.POPUPMANAGER));
    const appPopupEnabled : boolean | undefined = useSelector((app : AppState) => isAppPopupEnabledForDevice(app,detectDeviceOS()));
    const hasModalOpen = new URLSearchParams(location.search).has('type')
    const close = () => {
        dispatch(setPopupStatus(PopupStatus.HIDDEN));
    }


    let prevUserInfoLoaded = usePrevious(userInfoLoaded);
    let prevLoggedOutReady = usePrevious(loggedOutReady);
    let prevLoggedInReady = usePrevious(loggedInReady);
    let prevLoggedIn = usePrevious(loggedIn);


     const isContentLoaded = () => {
        return popupContentLoaded != ContentStatus.IN_PROGRESS && popupContentLoaded != ContentStatus.NONE;
    }

    useEffect(()=> {
        if(userInfoLoaded && isContentLoaded()) {
            if(loggedIn) {
                setLoggedInReady(true);
            } else {
                setLoggedOutReady(true);
            }
        }
    },[userInfoLoaded ,loggedIn, popupContentLoaded, prevUserInfoLoaded])

    //logged in
    useEffect(() => {
        if(loggedInReady === true && prevLoggedInReady === false) {
            if (appMode == AppMode.NONE && appPopupEnabled && shouldShowAppInstallPopup(settings)) {
                dispatch(setPopupStatus(PopupStatus.APP_INSTALL));
            } else if (shouldShowLoginPopup(popup?.login)){
                dispatch(setPopupStatus(PopupStatus.PROMOTION_LOGGED_IN));
            } else {
                dispatch(setPopupStatus(PopupStatus.IN_ACTIVE));
            }
        }

    },[loggedInReady, prevLoggedInReady]);

    //logged out
    useEffect(()=> {
        if(loggedOutReady === true && prevLoggedOutReady === false){
            if (shouldShowVisitPopup(popup?.visit)) {
                dispatch(setPopupStatus(PopupStatus.PROMOTION_VISIT));
            } else {
                dispatch(setPopupStatus(PopupStatus.IN_ACTIVE));
            }

        }
    },[loggedOutReady,prevLoggedOutReady])

    useEffect(()=>{
        if(prevLoggedIn == true && loggedIn == false) {
            const loginPopupSession = sessionStorageKey("loginPopup");
            loginPopupSession.remove()
        }
    },[prevLoggedIn, loggedIn]);


    if(popupContentLoaded != ContentStatus.SUCCESS) {
        return (
            <></>
        )
    }

    const disableOutsideClick = popup?.visit?.disableOutsideClick
    // if strapiBoolean is true, we want to show this modal when open new tab, refresh tab, go back to landing page from /casino, etc
    const popupModalWithDisableOutsideClick = disableOutsideClick ? status == PopupStatus.IN_ACTIVE || status == PopupStatus.PROMOTION_VISIT || status == null
                              : status == PopupStatus.PROMOTION_VISIT // this is the old behavior

    const inPromotionPopupPath = !(getPathType(location.search) == PATH.LOGIN
        || getPathType(location.search) == PATH.REGISTRATION
        || getPathType(location.search) == PATH.VERIFY_EMAIL
        || getPathType(location.search) == PATH.REGISTER_SUCCESS
        || getPathType(location.search) == PATH.TERMS_CONDITION
        || getPathType(location.search) == PATH.RECOVER)

    const showTermsAndConditionsModal = popupModalWithDisableOutsideClick && !hasModalOpen && popup?.visit && inPromotionPopupPath && !loggedIn;

    // @ts-ignore
    return (
        <>
            {
                showTermsAndConditionsModal
                // @ts-ignore
                && <PromotionPopup disableOutsideClick={disableOutsideClick} popup={popup?.visit} close={() => close()}/>}
            {/*todo replace disableOutsideClick with strapi prop*/}
            {status == PopupStatus.PROMOTION_LOGGED_IN
                && !hasModalOpen
                && popup?.login
                && <PromotionPopup disableOutsideClick={false} popup={popup?.login} close={() => close()}/>}
            {status == PopupStatus.APP_INSTALL
                && !hasModalOpen
                && <AppInstallPopUp close={() => close()}/>}
        </>
    )
}
